export default __webpack_public_path__ + "static/MaciejZadja-9efcfcb4b26f0c54eb035589b01fd15e.png";